// import React, { useState, useEffect } from "react";
// import { Plus, Search, Trash2, Edit2, Printer } from "lucide-react";
// import { FaChevronLeft, FaChevronRight, FaCheckCircle } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import ApiUrl from "../Environment/ApiUrl";


// const Purchases = ({ toggleSidebar }) => {


//   const [purchases, setPurchases] = useState([]);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [editingPurchase, setEditingPurchase] = useState(null);
//   const [deletingPurchase, setDeletingPurchase] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [itemsPerPage, setItemsPerPage] = useState(5);

//   const [formData, setFormData] = useState({
//     purchaseId: "",
//     purchaseDate: "",
//     dealerName: "MRF Tyres Ltd",
//     purchaseType: "New Tyre",
//     dealerId: "DLR001",
//     subTotal: "",
//     gstAmount: "",
//     netTotal: "",
//     paidAmount: "",
//     paymentStatus: "Paid",
//     purchaseItems: [],
//     purchasePaymentHistory: []
//   });


//    const [privileges, setPrivileges] = useState(null);
  
//     useEffect(() => {
//       const getaccess = localStorage.getItem("role");
//       setPrivileges(getaccess);
//     }, []);
  

//   const navigate = useNavigate();
//   const purchaseTypes = ["New Tyre", "Retreaded Tyre", "Tyre Tube", "Tyre Accessories"];
//   const paymentStatuses = ["Paid", "Partial", "Unpaid"];

//   useEffect(() => {
//     fetchPurchases();
//   }, []);

//   const fetchPurchases = async () => {
//     try {
//       setIsLoading(true);
//       setError(null);
//       const response = await axios.get(`${ApiUrl}/purchase_data.php`);
//       setPurchases(response.data?.data || []);
//     } catch (error) {
//       console.error("Error fetching purchases:", error);
//       setError("Failed to fetch purchases. Please try again.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handlePrint = (id) => {
//     navigate(`/purchase_bill/${id}`)
//   }

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const validateForm = () => {
//     if (
//       !formData.purchaseId.trim() ||
//       !formData.purchaseDate.trim() ||
//       !formData.dealerName.trim() ||
//       !formData.dealerId.trim() ||
//       !formData.subTotal ||
//       !formData.gstAmount ||
//       !formData.netTotal ||
//       !formData.paidAmount
//     ) {
//       throw new Error("Please fill in all required fields.");
//     }
//     return true;
//   };

//   const updatePurchaseToAPI = async (id, purchaseData) => {
//     try {
//       setIsLoading(true);
//       setError(null);
//       const response = await axios.put(
//         `${ApiUrl}/purchase_data.php/${id}`,
//         purchaseData,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//           timeout: 5000,
//         }
//       );

//         toast.success("purchase updated successfully!");

//       if (response.data.status) {
//         return response.data.data;
//       }
//       throw new Error(response.data.message || "Failed to update purchase");
//     } catch (error) {
//       console.error("API Error:", error);
//       let errorMessage = "Failed to update purchase";
//       if (error.response) {
//         errorMessage = error.response.data.message || errorMessage;
//       } else if (error.request) {
//         errorMessage = "No response from server. Please try again later.";
//       }
//       throw new Error(errorMessage);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const deletePurchaseFromAPI = async (id) => {
//     try {
//       setIsLoading(true);
//       setError(null);
//       const response = await axios.delete(`${ApiUrl}/purchase_data.php/${id}`);
//             toast.success(`purchase deleted successfully!`);
//       if (response.data.status) {
//         return true;
//       }
//       throw new Error(response.data.message || "Failed to delete purchase");
//     } catch (error) {
//       console.error("Error deleting purchase:", error);
//       let errorMessage = "Failed to delete purchase";
//       if (error.response) {
//         errorMessage = error.response.data.message || errorMessage;
//       } else if (error.request) {
//         errorMessage = "No response from server. Please try again later.";
//       }
//       throw new Error(errorMessage);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleEditConfirm = async () => {
//     try {
//       validateForm();
//       const updatedPurchase = await updatePurchaseToAPI(
//         editingPurchase.id,
//         formData
//       );
//       setPurchases((prev) =>
//         prev.map((purchase) =>
//           purchase.id === editingPurchase.id ? updatedPurchase : purchase
//         )
//       );
//       closeEditModal();
//     } catch (error) {
//       setError(error.message);
//     }
//   };

//   const handleDeleteConfirm = async () => {
//     try {
//       await deletePurchaseFromAPI(deletingPurchase.id);
//       setPurchases((prev) =>
//         prev.filter((purchase) => purchase.id !== deletingPurchase.id)
//       );
//       closeDeleteModal();
//           // toast.success(`purchase deleted successfully!`);

//     } catch (error) {
//       setError(error.message);
//     }
//   };

//   const handleClick = (id) => {
//     toggleSidebar();
//     navigate(`/purchase_update/${id}`);
//   };

//   const handlePurchase = () => {
//     toggleSidebar();
//     navigate("/Navigatepurchases");
//   };

//   const resetForm = () => {
//     setFormData({
//       purchaseId: "",
//       purchaseDate: "",
//       dealerName: "MRF Tyres Ltd",
//       purchaseType: "New Tyre",
//       dealerId: "DLR001",
//       subTotal: "",
//       gstAmount: "",
//       netTotal: "",
//       paidAmount: "",
//       paymentStatus: "Paid",
//       purchaseItems: [],
//       purchasePaymentHistory: []
//     });
//     setError(null);
//   };

//   const openEditModal = (purchase) => {
//     setEditingPurchase(purchase);
//     setFormData({
//       purchaseId: purchase.purchaseId || "",
//       purchaseDate: purchase.purchaseDate || "",
//       dealerName: purchase.dealerName || "MRF Tyres Ltd",
//       purchaseType: purchase.purchaseType || "New Tyre",
//       dealerId: purchase.dealerId || "DLR001",
//       subTotal: purchase.subTotal || "",
//       gstAmount: purchase.gstAmount || "",
//       netTotal: purchase.netTotal || "",
//       paidAmount: purchase.paidAmount || "",
//       paymentStatus: purchase.paymentStatus || "Paid",
//       purchaseItems: purchase.purchaseItems || [],
//       purchasePaymentHistory: purchase.purchasePaymentHistory || []
//     });
//     setShowEditModal(true);
//   };

//   const closeEditModal = () => {
//     setShowEditModal(false);
//     setEditingPurchase(null);
//     resetForm();
//   };

//   const openDeleteModal = (purchase) => {
//     setDeletingPurchase(purchase);
//     setShowDeleteModal(true);
//   };

//   const closeDeleteModal = () => {
//     setShowDeleteModal(false);
//     setDeletingPurchase(null);
//     setError(null);
//   };

//   const filteredPurchases = purchases.filter((purchase) =>
//     Object.values(purchase)
//       .join(" ")
//       .toLowerCase()
//       .includes(searchTerm.toLowerCase())
//   );

//   const totalPages = Math.ceil(filteredPurchases.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const currentPurchases = filteredPurchases.slice(
//     startIndex,
//     startIndex + itemsPerPage
//   );

//   const formatCurrency = (amount) => {
//     return `₹${Number(amount).toLocaleString("en-IN") || "0"}`;
//   };

//   const getStatusBadge = (status) => {
//     const statusClasses = {
//       Paid: "bg-success bg-opacity-10 text-success",
//       Partial: "bg-warning bg-opacity-10 text-warning",
//       Unpaid: "bg-danger bg-opacity-10 text-danger",
//     };

//     return (
//       <span
//         className={`d-inline-flex align-items-center gap-1 px-2 py-1 rounded-pill small fw-medium ${statusClasses[status]}`}
//       >
//         {status === "Paid" ? (
//           <FaCheckCircle size={14} />
//         ) : status === "Partial"}{" "}
//         {status}
//       </span>
//     );
//   };


//   return (
//     <div className="bg-white font-sans">
//               <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} closeOnClick pauseOnHover />
//       <div className="p-3 p-md-4 bg-white">
//         <div className="d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap" }}>
//           <h2 className="m-0 fs-5 fw-semibold text-dark">Purchases</h2>
//           <button
//             className="btn btn-danger d-flex align-items-center gap-2"
//             disabled={isLoading}
//             onClick={handlePurchase}
//           >
//             <Plus size={18} /> Add Purchase
//           </button>
//         </div>
//       </div>

//       <div className="card mx-3 mx-md-4 border mb-5">
//         <div className="card-header bg-white d-flex justify-content-between align-items-center p-3 border-bottom">
//           <div className="d-flex align-items-center gap-2" style={{ height: "36px", width: "120px" }}>
//             <div className="d-flex align-items-center justify-content-center" style={{ height: "28px", width: "14px" }}>
//               <svg width="14" height="14" viewBox="0 0 12 12" fill="none">
//                 <rect x="1" y="1" width="3" height="3" fill="#666" />
//                 <rect x="1" y="5" width="3" height="3" fill="#666" />
//                 <rect x="1" y="9" width="3" height="2" fill="#666" />
//                 <rect x="5" y="1" width="6" height="1" fill="#666" />
//                 <rect x="5" y="3" width="6" height="1" fill="#666" />
//                 <rect x="5" y="5" width="6" height="1" fill="#666" />
//                 <rect x="5" y="7" width="6" height="1" fill="#666" />
//                 <rect x="5" y="9" width="6" height="1" fill="#666" />
//               </svg>
//             </div>
//             <select
//               className="border-0 bg-transparent text-dark form-select form-select-sm"
//               style={{
//                 boxShadow: "none",
//                 outline: "none",
//                 lineHeight: "1.1",
//                 height: "28px",
//                 cursor: "pointer",
//                 width: "80px",
//                 paddingTop: "0",
//                 paddingBottom: "0",
//               }}
//               value={itemsPerPage}
//               onChange={(e) => {
//                 setItemsPerPage(Number(e.target.value));
//                 setCurrentPage(1);
//               }}
//             >
//               <option value="5">Show 5</option>
//               <option value="10">Show 10</option>
//               <option value="25">Show 25</option>
//               <option value={filteredPurchases.length}>Show All</option>
//             </select>
//           </div>

//           <div className="position-relative" style={{ width: "280px" }}>
//             <input
//               type="text"
//               placeholder="Search"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className="w-100 ps-3 pe-5 py-2 border rounded form-control"
//               disabled={isLoading}
//             />
//             <Search
//               size={18}
//               className="position-absolute top-50 end-0 translate-middle-y me-3 text-danger"
//               style={{ pointerEvents: "none" }}
//             />
//           </div>
//         </div>

//         {error && <div className="alert alert-danger m-3">{error}</div>}

//         <div className="card-body p-0">
//           <div className="table-responsive">
//             <table className="table table-hover mb-0">
//               <thead>
//                 <tr>
//                   <th style={{ backgroundColor: "#d3d3d3" }} className="p-3 text-start fw-semibold small border-bottom">
//                     S.No
//                   </th>
//                   <th style={{ backgroundColor: "#d3d3d3" }} className="p-3 text-start fw-semibold small border-bottom">
//                     Purchase No
//                   </th>
//                   <th style={{ backgroundColor: "#d3d3d3" }} className="p-3 text-start fw-semibold small border-bottom">
//                     Dealer Name
//                   </th>
//                   <th style={{ backgroundColor: "#d3d3d3" }} className="p-3 text-start fw-semibold small border-bottom">
//                     Date
//                   </th>                  
//                   <th style={{ backgroundColor: "#d3d3d3" }} className="p-3 text-start fw-semibold small border-bottom">
//                     Total Amount
//                   </th>
//                   <th style={{ backgroundColor: "#d3d3d3" }} className="p-3 text-start fw-semibold small border-bottom">
//                     Paid Amount
//                   </th>
//                   <th style={{ backgroundColor: "#d3d3d3" }} className="p-3 text-start fw-semibold small border-bottom">
//                     Total Item
//                   </th>
                  
//                   <th style={{ backgroundColor: "#d3d3d3" }} className="p-3 text-start fw-semibold small border-bottom">
//                     Action
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentPurchases.length > 0 ? (
//                   currentPurchases.map((purchase, index) => (
//                     <tr key={purchase.id} className="border-bottom">
//                       <td className="text-start small">{startIndex + index + 1}</td>
//                       <td className="text-start small fw-medium">{purchase.purchaseId}</td>
//                       <td className="text-start small fw-medium">{purchase.dealerName}</td>
//                       <td className="text-start small">{purchase.purchaseDate}</td>
                   
//                       <td className="text-start small">{formatCurrency(purchase.netTotal)}</td>
//                       <td className="text-start small">{formatCurrency(purchase.paidAmount)}</td>
//                       <td className="text-start small">
//                         {(purchase.purchaseItems?.[0]?.purchase_quantity) || "0"}
//                       </td>
                  
//                       <td className="text-start small">
//                         <div className="d-flex gap-2">
//                           <button
//                             onClick={() => openDeleteModal(purchase)}
//                             className="p-1 border-0 bg-transparent cursor-pointer text-muted"
//                             disabled={isLoading}
//                           >
//                             <Trash2 size={16} />
//                           </button>
//                           <button
//                             onClick={() => handleClick(purchase.id)}
//                             className="p-1 border-0 bg-transparent cursor-pointer text-muted"
//                             disabled={isLoading}
//                           >
//                             <Edit2 size={16} />
//                           </button>
//                           <button
//                             className="p-1 border-0 bg-transparent cursor-pointer text-muted"
//                             onClick={() => handlePrint(purchase.id)}
//                             disabled={isLoading}
//                             title="Print Invoice"
//                           >
//                             <Printer size={16} />
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="10" className="p-5 text-center text-muted">
//                       {isLoading ? "Loading purchases..." : "No purchases found"}
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {itemsPerPage < filteredPurchases.length && (
//             <div className="card-footer bg-white d-flex justify-content-between align-items-center border-top">
//               <button
//                 onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//                 disabled={currentPage === 1 || isLoading}
//                 className={`btn btn-sm d-flex align-items-center gap-2 ${currentPage === 1 ? "bg-light text-muted" : "bg-white text-dark"}`}
//               >
//                 <FaChevronLeft size={14} />
//                 <span className="ms-1 d-none d-md-inline">Previous</span>
//               </button>

//               <div className="d-flex gap-1">
//                 {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//                   let pageNum;
//                   if (totalPages <= 5) {
//                     pageNum = i + 1;
//                   } else if (currentPage <= 3) {
//                     pageNum = i + 1;
//                   } else if (currentPage >= totalPages - 2) {
//                     pageNum = totalPages - 4 + i;
//                   } else {
//                     pageNum = currentPage - 2 + i;
//                   }

//                   return (
//                     <button
//                       key={pageNum}
//                       onClick={() => setCurrentPage(pageNum)}
//                       disabled={isLoading}
//                       className={`btn btn-sm ${pageNum === currentPage
//                         ? "bg-danger bg-opacity-10 text-danger"
//                         : "bg-white text-dark"
//                         }`}
//                       style={{ width: "32px", height: "32px" }}
//                     >
//                       {pageNum}
//                     </button>
//                   );
//                 })}
//                 {totalPages > 5 && currentPage < totalPages - 2 && (
//                   <span className="px-2 py-1">...</span>
//                 )}
//                 {totalPages > 5 && currentPage < totalPages - 2 && (
//                   <button
//                     onClick={() => setCurrentPage(totalPages)}
//                     disabled={isLoading}
//                     className={`btn btn-sm ${totalPages === currentPage
//                       ? "bg-danger bg-opacity-10 text-danger"
//                       : "bg-white text-dark"
//                       }`}
//                     style={{ width: "32px", height: "32px" }}
//                   >
//                     {totalPages}
//                   </button>
//                 )}
//               </div>

//               <button
//                 onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
//                 disabled={currentPage === totalPages || isLoading}
//                 className={`btn btn-sm d-flex align-items-center gap-2 ${currentPage === totalPages ? "bg-light text-muted" : "bg-white text-dark"}`}
//               >
//                 <span className="ms-1 d-none d-md-inline">Next</span>
//                 <FaChevronRight size={14} />
//               </button>
//             </div>
//           )}
//         </div>
//       </div>

//       {showEditModal && (
//         <>
//           <div className="modal-backdrop show"></div>
//           <div className="modal d-block" tabIndex="-1" style={{ zIndex: 1051 }}>
//             <div className="modal-dialog modal-dialog-centered">
//               <div className="modal-content rounded" style={{ backgroundColor: "rgb(255, 240, 245)" }}>
//                 <div className="modal-header bg-pink-light border-bottom-0">
//                   <h5 className="modal-title m-0 small fw-semibold">Edit Purchase</h5>
//                   <button
//                     type="button"
//                     className="btn-close"
//                     onClick={closeEditModal}
//                     disabled={isLoading}
//                   ></button>
//                 </div>

//                 <div className="modal-body bg-pink-light">
//                   {error && <div className="alert alert-danger mb-3">{error}</div>}
//                   <div className="row g-3">
//                     <div className="col-md-6">
//                       <label className="form-label small fw-medium">
//                         Purchase ID <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control form-control-sm"
//                         name="purchaseId"
//                         value={formData.purchaseId}
//                         onChange={handleInputChange}
//                         placeholder="Enter Purchase ID"
//                         disabled={isLoading}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label className="form-label small fw-medium">
//                         Date <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         type="date"
//                         className="form-control form-control-sm"
//                         name="purchaseDate"
//                         value={formData.purchaseDate}
//                         onChange={handleInputChange}
//                         disabled={isLoading}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label className="form-label small fw-medium">
//                         Dealer ID <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control form-control-sm"
//                         name="dealerId"
//                         value={formData.dealerId}
//                         onChange={handleInputChange}
//                         placeholder="Enter Dealer ID"
//                         disabled={isLoading}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label className="form-label small fw-medium">
//                         Dealer Name <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control form-control-sm"
//                         name="dealerName"
//                         value={formData.dealerName}
//                         onChange={handleInputChange}
//                         placeholder="Enter Dealer Name"
//                         disabled={isLoading}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label className="form-label small fw-medium">Purchase Type</label>
//                       <select
//                         className="form-select form-select-sm"
//                         name="purchaseType"
//                         value={formData.purchaseType}
//                         onChange={handleInputChange}
//                         disabled={isLoading}
//                       >
//                         <option value="">Select Purchase Type</option>
//                         {purchaseTypes.map((type) => (
//                           <option key={type} value={type}>
//                             {type}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                     <div className="col-md-6">
//                       <label className="form-label small fw-medium">Sub Total</label>
//                       <input
//                         type="number"
//                         className="form-control form-control-sm"
//                         name="subTotal"
//                         value={formData.subTotal}
//                         onChange={handleInputChange}
//                         placeholder="Enter Sub Total"
//                         disabled={isLoading}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label className="form-label small fw-medium">GST Amount</label>
//                       <input
//                         type="number"
//                         className="form-control form-control-sm"
//                         name="gstAmount"
//                         value={formData.gstAmount}
//                         onChange={handleInputChange}
//                         placeholder="Enter GST Amount"
//                         disabled={isLoading}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label className="form-label small fw-medium">Total Amount</label>
//                       <input
//                         type="number"
//                         className="form-control form-control-sm"
//                         name="netTotal"
//                         value={formData.netTotal}
//                         onChange={handleInputChange}
//                         placeholder="Enter Total Amount"
//                         disabled={isLoading}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label className="form-label small fw-medium">Paid Amount</label>
//                       <input
//                         type="number"
//                         className="form-control form-control-sm"
//                         name="paidAmount"
//                         value={formData.paidAmount}
//                         onChange={handleInputChange}
//                         placeholder="Enter Paid Amount"
//                         disabled={isLoading}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label className="form-label small fw-medium">Payment Status</label>
//                       <select
//                         className="form-select form-select-sm"
//                         name="paymentStatus"
//                         value={formData.paymentStatus}
//                         onChange={handleInputChange}
//                         disabled={isLoading}
//                       >
//                         {paymentStatuses.map((status) => (
//                           <option key={status} value={status}>
//                             {status}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="modal-footer border-top-0">
//                   <button
//                     type="button"
//                     className="btn btn-sm btn-danger"
//                     onClick={closeEditModal}
//                     disabled={isLoading}
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="button"
//                     className="btn btn-sm btn-success"
//                     onClick={handleEditConfirm}
//                     disabled={isLoading}
//                   >
//                     {isLoading ? (
//                       <>
//                         <span
//                           className="spinner-border spinner-border-sm me-2"
//                           role="status"
//                           aria-hidden="true"
//                         ></span>
//                         Updating...
//                       </>
//                     ) : (
//                       "Update"
//                     )}
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </>
//       )}

//       {showDeleteModal && (
//         <>
//           <div className="modal-backdrop show"></div>
//           <div className="modal d-block" tabIndex="-1" style={{ zIndex: 1051 }}>
//             <div className="modal-dialog modal-dialog-centered">
//               <div className="modal-content rounded" style={{ backgroundColor: "rgb(255, 240, 245)" }}>
//                 <div className="modal-header bg-pink-light border-bottom-0">
//                   <h5 className="modal-title m-0 small fw-semibold">Delete Purchase</h5>
//                   <button
//                     type="button"
//                     className="btn-close"
//                     onClick={closeDeleteModal}
//                     disabled={isLoading}
//                   ></button>
//                 </div>

//                 <div className="modal-body bg-pink-light">
//                   {error && <div className="alert alert-danger mb-3">{error}</div>}
//                   <p className="mb-0">
//                     Are you sure you want to delete purchase {deletingPurchase.purchaseId}?
//                   </p>
//                 </div>

//                 <div className="modal-footer border-top-0">
//                   <button
//                     type="button"
//                     className="btn btn-sm btn-secondary"
//                     onClick={closeDeleteModal}
//                     disabled={isLoading}
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="button"
//                     className="btn btn-sm btn-danger"
//                     onClick={handleDeleteConfirm}
//                     disabled={isLoading}
//                   >
//                     {isLoading ? (
//                       <>
//                         <span
//                           className="spinner-border spinner-border-sm me-2"
//                           role="status"
//                           aria-hidden="true"
//                         ></span>
//                         Deleting...
//                       </>
//                     ) : (
//                       "Delete"
//                     )}
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default Purchases;



import React, { useState, useEffect } from "react";
import { Plus, Search, Trash2, Edit2, Printer } from "lucide-react";
import { FaChevronLeft, FaChevronRight, FaCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ApiUrl from "../Environment/ApiUrl";

const Purchases = ({ toggleSidebar }) => {
  const [purchases, setPurchases] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [editingPurchase, setEditingPurchase] = useState(null);
  const [deletingPurchase, setDeletingPurchase] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [privileges, setPrivileges] = useState(null);

  const [formData, setFormData] = useState({
    purchaseId: "",
    purchaseDate: "",
    dealerName: "MRF Tyres Ltd",
    purchaseType: "New Tyre",
    dealerId: "DLR001",
    subTotal: "",
    gstAmount: "",
    netTotal: "",
    paidAmount: "",
    paymentStatus: "Paid",
    purchaseItems: [],
    purchasePaymentHistory: []
  });

  const navigate = useNavigate();
  const purchaseTypes = ["New Tyre", "Retreaded Tyre", "Tyre Tube", "Tyre Accessories"];
  const paymentStatuses = ["Paid", "Partial", "Unpaid"];

  useEffect(() => {
    const getaccess = localStorage.getItem("role");
    setPrivileges(getaccess);
  }, []);

  useEffect(() => {
    fetchPurchases();
  }, []);

  const fetchPurchases = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await axios.get(`${ApiUrl}/purchase_data.php`);
      setPurchases(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching purchases:", error);
      setError("Failed to fetch purchases. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handlePrint = (id) => {
    navigate(`/purchase_bill/${id}`)
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    if (
      !formData.purchaseId.trim() ||
      !formData.purchaseDate.trim() ||
      !formData.dealerName.trim() ||
      !formData.dealerId.trim() ||
      !formData.subTotal ||
      !formData.gstAmount ||
      !formData.netTotal ||
      !formData.paidAmount
    ) {
      throw new Error("Please fill in all required fields.");
    }
    return true;
  };

  const updatePurchaseToAPI = async (id, purchaseData) => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await axios.put(
        `${ApiUrl}/purchase_data.php/${id}`,
        purchaseData,
        {
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 5000,
        }
      );

      toast.success("purchase updated successfully!");

      if (response.data.status) {
        return response.data.data;
      }
      throw new Error(response.data.message || "Failed to update purchase");
    } catch (error) {
      console.error("API Error:", error);
      let errorMessage = "Failed to update purchase";
      if (error.response) {
        errorMessage = error.response.data.message || errorMessage;
      } else if (error.request) {
        errorMessage = "No response from server. Please try again later.";
      }
      throw new Error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const deletePurchaseFromAPI = async (id) => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await axios.delete(`${ApiUrl}/purchase_data.php/${id}`);
      toast.success(`purchase deleted successfully!`);
      if (response.data.status) {
        return true;
      }
      throw new Error(response.data.message || "Failed to delete purchase");
    } catch (error) {
      console.error("Error deleting purchase:", error);
      let errorMessage = "Failed to delete purchase";
      if (error.response) {
        errorMessage = error.response.data.message || errorMessage;
      } else if (error.request) {
        errorMessage = "No response from server. Please try again later.";
      }
      throw new Error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditConfirm = async () => {
    try {
      validateForm();
      const updatedPurchase = await updatePurchaseToAPI(
        editingPurchase.id,
        formData
      );
      setPurchases((prev) =>
        prev.map((purchase) =>
          purchase.id === editingPurchase.id ? updatedPurchase : purchase
        )
      );
      closeEditModal();
    } catch (error) {
      setError(error.message);
    }
  };

  const handleDeleteConfirm = async () => {
    try {
      await deletePurchaseFromAPI(deletingPurchase.id);
      setPurchases((prev) =>
        prev.filter((purchase) => purchase.id !== deletingPurchase.id)
      );
      closeDeleteModal();
    } catch (error) {
      setError(error.message);
    }
  };

  const handleClick = (id) => {
    toggleSidebar();
    navigate(`/purchase_update/${id}`);
  };

  const handlePurchase = () => {
    toggleSidebar();
    navigate("/Navigatepurchases");
  };

  const resetForm = () => {
    setFormData({
      purchaseId: "",
      purchaseDate: "",
      dealerName: "MRF Tyres Ltd",
      purchaseType: "New Tyre",
      dealerId: "DLR001",
      subTotal: "",
      gstAmount: "",
      netTotal: "",
      paidAmount: "",
      paymentStatus: "Paid",
      purchaseItems: [],
      purchasePaymentHistory: []
    });
    setError(null);
  };

  const openEditModal = (purchase) => {
    setEditingPurchase(purchase);
    setFormData({
      purchaseId: purchase.purchaseId || "",
      purchaseDate: purchase.purchaseDate || "",
      dealerName: purchase.dealerName || "MRF Tyres Ltd",
      purchaseType: purchase.purchaseType || "New Tyre",
      dealerId: purchase.dealerId || "DLR001",
      subTotal: purchase.subTotal || "",
      gstAmount: purchase.gstAmount || "",
      netTotal: purchase.netTotal || "",
      paidAmount: purchase.paidAmount || "",
      paymentStatus: purchase.paymentStatus || "Paid",
      purchaseItems: purchase.purchaseItems || [],
      purchasePaymentHistory: purchase.purchasePaymentHistory || []
    });
    setShowEditModal(true);
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setEditingPurchase(null);
    resetForm();
  };

  const openDeleteModal = (purchase) => {
    setDeletingPurchase(purchase);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setDeletingPurchase(null);
    setError(null);
  };

  const filteredPurchases = purchases.filter((purchase) =>
    Object.values(purchase)
      .join(" ")
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredPurchases.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentPurchases = filteredPurchases.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const formatCurrency = (amount) => {
    return `₹${Number(amount).toLocaleString("en-IN") || "0"}`;
  };

  const getStatusBadge = (status) => {
    const statusClasses = {
      Paid: "bg-success bg-opacity-10 text-success",
      Partial: "bg-warning bg-opacity-10 text-warning",
      Unpaid: "bg-danger bg-opacity-10 text-danger",
    };

    return (
      <span
        className={`d-inline-flex align-items-center gap-1 px-2 py-1 rounded-pill small fw-medium ${statusClasses[status]}`}
      >
        {status === "Paid" ? (
          <FaCheckCircle size={14} />
        ) : status === "Partial"}{" "}
        {status}
      </span>
    );
  };

  return (
    <div className="bg-white font-sans">
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} closeOnClick pauseOnHover />
      <div className="p-3 p-md-4 bg-white">
        <div className="d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap" }}>
          <h2 className="m-0 fs-5 fw-semibold text-dark">Purchases</h2>
          {(privileges === "Admin" || privileges === "Staff" || privileges === "Manager") && (
            <button
              className="btn btn-danger d-flex align-items-center gap-2"
              disabled={isLoading}
              onClick={handlePurchase}
            >
              <Plus size={18} /> Add Purchase
            </button>
          )}
        </div>
      </div>

      <div className="card mx-3 mx-md-4 border mb-5">
        <div className="card-header bg-white d-flex justify-content-between align-items-center p-3 border-bottom">
          <div className="d-flex align-items-center gap-2" style={{ height: "36px", width: "120px" }}>
            <div className="d-flex align-items-center justify-content-center" style={{ height: "28px", width: "14px" }}>
              <svg width="14" height="14" viewBox="0 0 12 12" fill="none">
                <rect x="1" y="1" width="3" height="3" fill="#666" />
                <rect x="1" y="5" width="3" height="3" fill="#666" />
                <rect x="1" y="9" width="3" height="2" fill="#666" />
                <rect x="5" y="1" width="6" height="1" fill="#666" />
                <rect x="5" y="3" width="6" height="1" fill="#666" />
                <rect x="5" y="5" width="6" height="1" fill="#666" />
                <rect x="5" y="7" width="6" height="1" fill="#666" />
                <rect x="5" y="9" width="6" height="1" fill="#666" />
              </svg>
            </div>
            <select
              className="border-0 bg-transparent text-dark form-select form-select-sm"
              style={{
                boxShadow: "none",
                outline: "none",
                lineHeight: "1.1",
                height: "28px",
                cursor: "pointer",
                width: "80px",
                paddingTop: "0",
                paddingBottom: "0",
              }}
              value={itemsPerPage}
              onChange={(e) => {
                setItemsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value="5">Show 5</option>
              <option value="10">Show 10</option>
              <option value="25">Show 25</option>
              <option value={filteredPurchases.length}>Show All</option>
            </select>
          </div>

          <div className="position-relative" style={{ width: "280px" }}>
            <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-100 ps-3 pe-5 py-2 border rounded form-control"
              disabled={isLoading}
            />
            <Search
              size={18}
              className="position-absolute top-50 end-0 translate-middle-y me-3 text-danger"
              style={{ pointerEvents: "none" }}
            />
          </div>
        </div>

        {error && <div className="alert alert-danger m-3">{error}</div>}

        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-hover mb-0">
              <thead>
                <tr>
                  <th style={{ backgroundColor: "#d3d3d3" }} className="p-3 text-start fw-semibold small border-bottom">
                    S.No
                  </th>
                  <th style={{ backgroundColor: "#d3d3d3" }} className="p-3 text-start fw-semibold small border-bottom">
                    Purchase No
                  </th>
                  <th style={{ backgroundColor: "#d3d3d3" }} className="p-3 text-start fw-semibold small border-bottom">
                    Dealer Name
                  </th>
                  <th style={{ backgroundColor: "#d3d3d3" }} className="p-3 text-start fw-semibold small border-bottom">
                    Date
                  </th>                  
                  <th style={{ backgroundColor: "#d3d3d3" }} className="p-3 text-start fw-semibold small border-bottom">
                    Total Amount
                  </th>
                  <th style={{ backgroundColor: "#d3d3d3" }} className="p-3 text-start fw-semibold small border-bottom">
                    Paid Amount
                  </th>
                  <th style={{ backgroundColor: "#d3d3d3" }} className="p-3 text-start fw-semibold small border-bottom">
                    Total Item
                  </th>
                  
                  <th style={{ backgroundColor: "#d3d3d3" }} className="p-3 text-start fw-semibold small border-bottom">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentPurchases.length > 0 ? (
                  currentPurchases.map((purchase, index) => (
                    <tr key={purchase.id} className="border-bottom">
                      <td className="text-start small">{startIndex + index + 1}</td>
                      <td className="text-start small fw-medium">{purchase.purchaseId}</td>
                      <td className="text-start small fw-medium">{purchase.dealerName}</td>
                      <td className="text-start small">{purchase.purchaseDate}</td>
                   
                      <td className="text-start small">{formatCurrency(purchase.netTotal)}</td>
                      <td className="text-start small">{formatCurrency(purchase.paidAmount)}</td>
                      <td className="text-start small">
                        {(purchase.purchaseItems?.[0]?.purchase_quantity) || "0"}
                      </td>
                  
                      <td className="text-start small">
                        <div className="d-flex gap-2">
                          {privileges === "Admin" && (
                            <button
                              onClick={() => openDeleteModal(purchase)}
                              className="p-1 border-0 bg-transparent cursor-pointer text-muted"
                              disabled={isLoading}
                            >
                              <Trash2 size={16} />
                            </button>
                          )}
                          {(privileges === "Admin" || privileges === "Manager") && (
                            <button
                              onClick={() => handleClick(purchase.id)}
                              className="p-1 border-0 bg-transparent cursor-pointer text-muted"
                              disabled={isLoading}
                            >
                              <Edit2 size={16} />
                            </button>
                          )}
                          <button
                            className="p-1 border-0 bg-transparent cursor-pointer text-muted"
                            onClick={() => handlePrint(purchase.id)}
                            disabled={isLoading}
                            title="Print Invoice"
                          >
                            <Printer size={16} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className="p-5 text-center text-muted">
                      {isLoading ? "Loading purchases..." : "No purchases found"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {itemsPerPage < filteredPurchases.length && (
            <div className="card-footer bg-white d-flex justify-content-between align-items-center border-top">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1 || isLoading}
                className={`btn btn-sm d-flex align-items-center gap-2 ${currentPage === 1 ? "bg-light text-muted" : "bg-white text-dark"}`}
              >
                <FaChevronLeft size={14} />
                <span className="ms-1 d-none d-md-inline">Previous</span>
              </button>

              <div className="d-flex gap-1">
                {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                  let pageNum;
                  if (totalPages <= 5) {
                    pageNum = i + 1;
                  } else if (currentPage <= 3) {
                    pageNum = i + 1;
                  } else if (currentPage >= totalPages - 2) {
                    pageNum = totalPages - 4 + i;
                  } else {
                    pageNum = currentPage - 2 + i;
                  }

                  return (
                    <button
                      key={pageNum}
                      onClick={() => setCurrentPage(pageNum)}
                      disabled={isLoading}
                      className={`btn btn-sm ${pageNum === currentPage
                        ? "bg-danger bg-opacity-10 text-danger"
                        : "bg-white text-dark"
                        }`}
                      style={{ width: "32px", height: "32px" }}
                    >
                      {pageNum}
                    </button>
                  );
                })}
                {totalPages > 5 && currentPage < totalPages - 2 && (
                  <span className="px-2 py-1">...</span>
                )}
                {totalPages > 5 && currentPage < totalPages - 2 && (
                  <button
                    onClick={() => setCurrentPage(totalPages)}
                    disabled={isLoading}
                    className={`btn btn-sm ${totalPages === currentPage
                      ? "bg-danger bg-opacity-10 text-danger"
                      : "bg-white text-dark"
                      }`}
                    style={{ width: "32px", height: "32px" }}
                  >
                    {totalPages}
                  </button>
                )}
              </div>

              <button
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages || isLoading}
                className={`btn btn-sm d-flex align-items-center gap-2 ${currentPage === totalPages ? "bg-light text-muted" : "bg-white text-dark"}`}
              >
                <span className="ms-1 d-none d-md-inline">Next</span>
                <FaChevronRight size={14} />
              </button>
            </div>
          )}
        </div>
      </div>

      {showEditModal && (
        <>
          <div className="modal-backdrop show"></div>
          <div className="modal d-block" tabIndex="-1" style={{ zIndex: 1051 }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content rounded" style={{ backgroundColor: "rgb(255, 240, 245)" }}>
                <div className="modal-header bg-pink-light border-bottom-0">
                  <h5 className="modal-title m-0 small fw-semibold">Edit Purchase</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeEditModal}
                    disabled={isLoading}
                  ></button>
                </div>

                <div className="modal-body bg-pink-light">
                  {error && <div className="alert alert-danger mb-3">{error}</div>}
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label small fw-medium">
                        Purchase ID <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="purchaseId"
                        value={formData.purchaseId}
                        onChange={handleInputChange}
                        placeholder="Enter Purchase ID"
                        disabled={isLoading}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small fw-medium">
                        Date <span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        name="purchaseDate"
                        value={formData.purchaseDate}
                        onChange={handleInputChange}
                        disabled={isLoading}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small fw-medium">
                        Dealer ID <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="dealerId"
                        value={formData.dealerId}
                        onChange={handleInputChange}
                        placeholder="Enter Dealer ID"
                        disabled={isLoading}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small fw-medium">
                        Dealer Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="dealerName"
                        value={formData.dealerName}
                        onChange={handleInputChange}
                        placeholder="Enter Dealer Name"
                        disabled={isLoading}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small fw-medium">Purchase Type</label>
                      <select
                        className="form-select form-select-sm"
                        name="purchaseType"
                        value={formData.purchaseType}
                        onChange={handleInputChange}
                        disabled={isLoading}
                      >
                        <option value="">Select Purchase Type</option>
                        {purchaseTypes.map((type) => (
                          <option key={type} value={type}>
                            {type}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small fw-medium">Sub Total</label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        name="subTotal"
                        value={formData.subTotal}
                        onChange={handleInputChange}
                        placeholder="Enter Sub Total"
                        disabled={isLoading}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small fw-medium">GST Amount</label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        name="gstAmount"
                        value={formData.gstAmount}
                        onChange={handleInputChange}
                        placeholder="Enter GST Amount"
                        disabled={isLoading}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small fw-medium">Total Amount</label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        name="netTotal"
                        value={formData.netTotal}
                        onChange={handleInputChange}
                        placeholder="Enter Total Amount"
                        disabled={isLoading}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small fw-medium">Paid Amount</label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        name="paidAmount"
                        value={formData.paidAmount}
                        onChange={handleInputChange}
                        placeholder="Enter Paid Amount"
                        disabled={isLoading}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small fw-medium">Payment Status</label>
                      <select
                        className="form-select form-select-sm"
                        name="paymentStatus"
                        value={formData.paymentStatus}
                        onChange={handleInputChange}
                        disabled={isLoading}
                      >
                        {paymentStatuses.map((status) => (
                          <option key={status} value={status}>
                            {status}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="modal-footer border-top-0">
                  <button
                    type="button"
                    className="btn btn-sm btn-danger"
                    onClick={closeEditModal}
                    disabled={isLoading}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-success"
                    onClick={handleEditConfirm}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Updating...
                      </>
                    ) : (
                      "Update"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {showDeleteModal && (
        <>
          <div className="modal-backdrop show"></div>
          <div className="modal d-block" tabIndex="-1" style={{ zIndex: 1051 }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content rounded" style={{ backgroundColor: "rgb(255, 240, 245)" }}>
                <div className="modal-header bg-pink-light border-bottom-0">
                  <h5 className="modal-title m-0 small fw-semibold">Delete Purchase</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeDeleteModal}
                    disabled={isLoading}
                  ></button>
                </div>

                <div className="modal-body bg-pink-light">
                  {error && <div className="alert alert-danger mb-3">{error}</div>}
                  <p className="mb-0">
                    Are you sure you want to delete purchase {deletingPurchase.purchaseId}?
                  </p>
                </div>

                <div className="modal-footer border-top-0">
                  <button
                    type="button"
                    className="btn btn-sm btn-secondary"
                    onClick={closeDeleteModal}
                    disabled={isLoading}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-danger"
                    onClick={handleDeleteConfirm}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Deleting...
                      </>
                    ) : (
                      "Delete"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Purchases;